import { z } from 'zod';

import { WriteoffId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';

export const Writeoff = z.object({
  id: WriteoffId,
  effectiveDate: zodJSPlainDate,
  status: z.enum(['active']), // we don't currently support cancelled or reversed writeoffs but should in future so adding status here spares us a migration.
  amounts: z.object({
    principal: z.number().default(0),
    interest: z.number().default(0),
    suspense: z.number(), // only negative suspense balances can be written off
    escrow: z.number(), // escrow advances
    corporateAdvances: z.number().default(0),
    fees: z.number().default(0),
  }),
  comment: z.string().optional(),
  createdAt: zodJSInstantDate,
  updatedAt: zodJSInstantDate,
});

export type Writeoff = z.infer<typeof Writeoff>;

export const WriteoffInput = Writeoff.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export type WriteoffInput = z.infer<typeof WriteoffInput>;
